<template>

  <div class="hgg" :style="getColumns()" v-if="hasIcons">

    <!-- W tel or onl enquiry -->
    <div  v-for="(wave, index) in waves" :key="index"
          v-bind:style="[ getBgColorStyle(wave, index) ]">
      <div style="line-height: 0.5rem;height: 11px;" v-if="getValue(wave) !== null">
        <font-awesome-icon  :icon="['fas', 'envelope']"
                            class="icosize"
                            v-if="getIsOnline(wave)" />
        <font-awesome-icon  :icon="['fas', 'phone']"
                            class="icosize"
                            v-if="getIsTelephone(wave)" />
        <font-awesome-icon  :icon="['fas', 'tablet-alt']"
                            class="icosize"
                            v-if="getIsDigital(wave)" />
      </div>
      <div v-else style="line-height: 0.75rem; height: 10px;" />
      <div style="line-height: 0.75rem; padding-top: 0.15rem;" class="n5 bu">{{ getValue(wave) }}</div>
    </div>
  </div>

  <!-- v-bind:class="[ wave.slot ]" -->
  <!-- Blank value, w/o tel or onl enquiry -->
  <div class="hgg"  :style="getColumns()" v-else>
    <div  v-for="(wave, index) in waves" :key="index"
          class="n5 bu"
          :class="[ { padtop: !editHeight, padtophalf: editHeight }]"
          v-bind:style="[ getBgColorStyle(wave, index) ]">
      {{ getValue(wave) }}
    </div>
  </div>
</template>

<script>
import RollingWaveOrder from '@/mixins/bmw/RollingWaveOrder';
import ThresholdColor from '@/mixins/ThresholdColor-APP_TARGET';

export default {
  mixins: [ ThresholdColor, RollingWaveOrder ],

  props: {
    kpi: { type: Object },
    overall: { type: Object },
    colorMode: {
      type: String,
      validator: value => {
        return value === 'll' || value === 'kpi' || value === 'mono';
      },
      default: function () {
        return 'kpi';
      }
    },
    history: { type: Array },
    thresholds: { type: Array, required: true },
    waves: { type: Array, required: true },
    hasIcons: { type: Boolean, default: function() { return false; }},
    editHeight: { type: Boolean, default: false }
  },

  methods: {
    getColumns() {
      return { 'grid-template-columns': '1fr '.repeat(this.waves.length) };
    },

    getBackgroundStyle(color) {
      return { 'background-color': color };
    },

    getBgColorStyle(wave, index) {
      let nr = this.getValue(wave, index);
      if (nr === null || this.colorMode ==='mono')
        return this.getBackgroundStyle('#F2F2F2');

      let value = _.toNumber(nr);
      if (!_.isFinite(value))
        return this.getBackgroundStyle('#F2F2F2');

      if (this.colorMode === 'kpi') {
        const color = this.getThresholdColor(this.thresholds, value, '#fff');
        return this.getBackgroundStyle(color);
      }

      if (this.colorMode === 'll') {
        if (value >= 10)
          return this.getBackgroundStyle(this.thresholds[0].color);
        else if (value >= 5)
          return this.getBackgroundStyle(this.thresholds[1].color);
        else
          return this.getBackgroundStyle(this.thresholds[2].color);
      }
    },

    getIsTelephone(wave, index) {
      let nr = this.getValue(wave);
      let item = this.findQuarter(this.overall, wave);
      if (!item || !nr) {
        return false;
      }
      return item ? ('NumberOfShopsTelephone' in item || 'NumberOfShopsTelephoneIntegrated' in item) : false;
    },
    getIsOnline(wave, index) {
      let nr = this.getValue(wave);
      let item = this.findQuarter(this.overall, wave);
      if (!item || !nr) {
        return false;
      }
      return item ? ('NumberOfShopsOnline' in item || 'NumberOfShopsOnlineIntegrated' in item || 'NumberOfShopsPureOnline' in item) : false;
    },
    getIsDigital(wave, index) {
      let nr = this.getValue(wave);
      let item = this.findQuarter(this.overall, wave);
      if (!item || !nr) {
        return false;
      }
      return item ? ('NumberOfShops100PercentDigital' in item) : false;
    }
  }
};

</script>

<style lang="scss" scoped>
  .hgg {
    display: grid;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 9pt;
  }
  .padtop {
    padding-top: 0.75rem;
  }
  .padtophalf {
    padding-top: 0.375rem;
  }
  .n5 {
    letter-spacing: -0.05em;
  }
  .bu { /* bold upper */
    font-weight: bold;
    text-transform: uppercase;
  }
  .icosize {
    height:8px;
    width: 8px;
  }

</style>
